import { z } from "zod";

export const UserSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  photo: z.string().nullable(),
  language: z.string().nullable(),
  phone_number: z.string().nullable()
});

export const UpdateUserRequestSchema = UserSchema.partial().omit({ id: true });

export const UserResponseSchema = UserSchema;

export const UpdateUserResponseSchema = z.object({
  name: z.string().nullable(),
  photo: z.string().nullable(),
  language: z.string().nullable()
});
